import {useQuery} from '@tanstack/react-query'
import {useState, useEffect} from 'react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useContentAsset} from '../hooks/use-content-asset'

export const useBraze = (userId) => {
    const {locale} = useMultiSite()
    const contentAssets = useContentAsset(['braze-content-asset'], locale?.id)
    const [isPageLoaded, setPageLoaded] = useState(false)

    useEffect(() => {
        if (document.readyState === 'complete') {
            setPageLoaded(true)
        } else {
            window.addEventListener('load', () => setPageLoaded(true))
        }
    }, [])

    const enabled = !!contentAssets?.['braze-content-asset']?.body && isPageLoaded

    useQuery({
        queryKey: ['braze-init', userId, locale?.id],
        queryFn: async () => {
            const config = JSON.parse(contentAssets['braze-content-asset'].body)
            const braze = await import('@braze/web-sdk')
            const baseUrl = config?.brazeBaseUrl
            const apiKey = config?.brazeApiKey
            if (!braze.isInitialized()) {
                braze.initialize(apiKey, {
                    baseUrl,
                    allowUserSuppliedJavascript: true,
                    enableLogging: false
                })
            }
            if (userId) {
                braze.changeUser(userId)
            }

            const executeLogic = new Function('braze', 'features', config.logic)
            executeLogic(braze, config.features)
            braze.openSession()
            return true
        },
        enabled,
        staleTime: 5 * 60000,
        cacheTime: 30 * 60000
    })
}
